export default __webpack_public_path__ + "static/media/batch_prediction.5d8d272e.svg";